import { TagIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";

export default function LimitedTimeOffer() {
    const navigate = useNavigate();

    return (
        <section className="w-full py-6 sm:py-8">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                <div
                    className="
                        group
                        relative
                        overflow-hidden
                        rounded-2xl
                        bg-[#0B2F6B]
                        min-h-[140px]
                        sm:min-h-[150px]
                        flex
                        items-center
                        shadow-md
                        hover:shadow-xl
                        transition-shadow
                        duration-500
                    "
                >

                    {/* ==========================================
                        Animated Background Skyline
                    =========================================== */}

                    <div
                        className="
                            absolute
                            inset-y-0
                            right-0
                            w-full
                            lg:w-[55%]
                            opacity-20
                            pointer-events-none
                            offer-skyline
                        "
                        style={{
                            backgroundImage:
                                "url('/images/dubai-skyline.png')",
                            backgroundPosition: "right center",
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                        }}
                    />

                    {/* Gradient Overlay */}
                    <div
                        className="
                            absolute
                            inset-0
                            bg-gradient-to-r
                            from-[#0B2F6B]
                            via-[#0B2F6B]/95
                            to-[#174EA6]/50
                            pointer-events-none
                        "
                    />

                    {/* Decorative glow */}
                    <div
                        className="
                            absolute
                            -right-20
                            -top-20
                            w-64
                            h-64
                            rounded-full
                            bg-[#174EA6]/20
                            blur-3xl
                            pointer-events-none
                            group-hover:bg-[#174EA6]/30
                            transition-all
                            duration-700
                        "
                    />

                    {/* ==========================================
                        Content
                    =========================================== */}

                    <div
                        className="
                            relative
                            z-10
                            w-full
                            px-5
                            sm:px-8
                            lg:px-10
                            py-6
                            flex
                            flex-col
                            sm:flex-row
                            items-center
                            gap-5
                            sm:gap-6
                            lg:gap-7
                        "
                    >

                        {/* ======================================
                            Offer Icon
                        ======================================= */}

                        <div className="relative flex-shrink-0">

                            {/* Outer pulse */}
                            <div
                                className="
                                    absolute
                                    inset-0
                                    rounded-2xl
                                    bg-[#174EA6]
                                    opacity-40
                                    offer-icon-pulse
                                "
                            />

                            <div
                                className="
                                    relative
                                    w-16
                                    h-16
                                    sm:w-[72px]
                                    sm:h-[72px]
                                    rounded-2xl
                                    bg-[#174EA6]
                                    border
                                    border-white/10
                                    flex
                                    items-center
                                    justify-center
                                    shadow-lg
                                    group-hover:scale-105
                                    transition-transform
                                    duration-500
                                "
                            >
                                <TagIcon
                                    className="
                                        w-9
                                        h-9
                                        sm:w-10
                                        sm:h-10
                                        text-white
                                    "
                                    strokeWidth={1.5}
                                />

                                {/* Percentage badge */}
                                <span
                                    className="
                                        absolute
                                        -right-2
                                        -top-2
                                        w-6
                                        h-6
                                        rounded-full
                                        bg-[#FFC928]
                                        text-[#0F172A]
                                        text-[10px]
                                        font-extrabold
                                        flex
                                        items-center
                                        justify-center
                                        shadow-md
                                        offer-badge-pulse
                                    "
                                >
                                    %
                                </span>
                            </div>
                        </div>

                        {/* ======================================
                            Text
                        ======================================= */}

                        <div
                            className="
                                flex-1
                                text-center
                                sm:text-left
                            "
                        >
                            <div
                                className="
                                    flex
                                    items-center
                                    justify-center
                                    sm:justify-start
                                    gap-2
                                    mb-1
                                "
                            >
                                {/* Animated dot */}
                                <span
                                    className="
                                        w-1.5
                                        h-1.5
                                        rounded-full
                                        bg-[#FFC928]
                                        offer-dot-pulse
                                    "
                                />

                                <span
                                    className="
                                        text-[#FFC928]
                                        text-[11px]
                                        sm:text-xs
                                        font-bold
                                        uppercase
                                        tracking-wide
                                    "
                                >
                                    Limited Time Offer
                                </span>
                            </div>

                            <h2
                                className="
                                    text-xl
                                    sm:text-2xl
                                    lg:text-[22px]
                                    font-bold
                                    !text-white
                                    leading-tight
                                "
                            >
                                Exclusive Deals Just For You!
                            </h2>

                            <p
                                className="
                                    mt-1
                                    text-xs
                                    sm:text-sm
                                    text-white/80
                                "
                            >
                                Up to 40% OFF on selected hotels.
                                Book now and save big!
                            </p>
                        </div>

                        {/* ======================================
                            CTA
                        ======================================= */}

                        <div
                            className="
                                flex-shrink-0
                                w-full
                                sm:w-auto
                            "
                        >
                            <button
                                type="button"
                                onClick={() => navigate("/offers")}
                                className="
                                    relative
                                    overflow-hidden
                                    w-full
                                    sm:w-auto
                                    min-w-[145px]
                                    h-11
                                    px-6
                                    rounded-lg
                                    bg-[#FFC928]
                                    hover:bg-[#F5BA00]
                                    text-[#0F172A]
                                    text-sm
                                    font-bold
                                    shadow-md
                                    hover:shadow-xl
                                    transition-all
                                    duration-300
                                    hover:-translate-y-0.5
                                "
                            >
                                {/* Button shine */}
                                <span
                                    className="
                                        absolute
                                        inset-y-0
                                        -left-12
                                        w-8
                                        rotate-12
                                        bg-white/40
                                        blur-sm
                                        button-shine
                                    "
                                />

                                <span className="relative z-10">
                                    View All Offers
                                </span>
                            </button>
                        </div>

                    </div>
                </div>
            </div>

            {/* ==========================================
                Custom Animations
            =========================================== */}

            <style>{`
                /* Slowly moves the Dubai skyline */
                @keyframes offerSkyline {
                    0% {
                        transform: scale(1);
                    }

                    50% {
                        transform: scale(1.04);
                    }

                    100% {
                        transform: scale(1);
                    }
                }

                .offer-skyline {
                    animation: offerSkyline 8s ease-in-out infinite;
                }


                /* Icon glow */
                @keyframes offerIconPulse {
                    0%,
                    100% {
                        transform: scale(1);
                        opacity: 0.35;
                    }

                    50% {
                        transform: scale(1.12);
                        opacity: 0;
                    }
                }

                .offer-icon-pulse {
                    animation: offerIconPulse 2.2s ease-out infinite;
                }


                /* Percentage badge */
                @keyframes offerBadgePulse {
                    0%,
                    100% {
                        transform: scale(1);
                    }

                    50% {
                        transform: scale(1.15);
                    }
                }

                .offer-badge-pulse {
                    animation: offerBadgePulse 1.8s ease-in-out infinite;
                }


                /* Small yellow dot */
                @keyframes offerDotPulse {
                    0%,
                    100% {
                        transform: scale(1);
                        opacity: 1;
                    }

                    50% {
                        transform: scale(1.5);
                        opacity: 0.5;
                    }
                }

                .offer-dot-pulse {
                    animation: offerDotPulse 1.5s ease-in-out infinite;
                }


                /* Button shine */
                @keyframes buttonShine {
                    0% {
                        left: -50px;
                    }

                    60%,
                    100% {
                        left: 120%;
                    }
                }

                .button-shine {
                    animation: buttonShine 4s ease-in-out infinite;
                }


                /* Accessibility */
                @media (prefers-reduced-motion: reduce) {
                    .offer-skyline,
                    .offer-icon-pulse,
                    .offer-badge-pulse,
                    .offer-dot-pulse,
                    .button-shine {
                        animation: none;
                    }
                }
            `}</style>
        </section>
    );
}